<template>
  <div class="corpWebsite">
    <div class="corpWebsite-content">
      <div class="menuArea" v-show="isShowMenu">
        <div
          v-for="item in menuList"
          :key="item.type"
          class="menuItem"
          :class="{ active: isActiveMenuType === item.type }"
          @click="toJump(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Header from "@/views/layout/header.vue";
import Footer from "@/views/layout/footer.vue";

export default {
  name: "corpWebsite",
  components: {
    Header,
    Footer,
  },
  computed: {
    corpUserInfo() {
      return this.$store.state.user.corpUserInfo;
    },
  },
  data() {
    return {
      menuList: [
        { label: "全部商品", type: 101 },
        { label: "协议商品", type: 102 },
        // { label: "常购商品", type: 103 },
        { label: "集团协议商品", type: 104 },
      ],
    };
  },
  computed: {
    isShowMenu() {
      return (
        this.$route.fullPath.includes("agreedGoods") ||
        this.$route.fullPath.includes("boughtGoods") ||
        this.$route.fullPath.includes("groupAgreedGoods")
      );
    },
    isActiveMenuType() {
      const path = this.$route.fullPath;
      if (path.includes("agreedGoods")) {
        return 102;
      } else if (path.includes("boughtGoods")) {
        return 103;
      } else if (path.includes("groupAgreedGoods")) {
        return 104;
      } else {
        return 0;
      }
    },
  },
  methods: {
    toJump(res) {
      switch (res.type) {
        case 101:
          this.routerHandle("home");
          break;
        case 102:
          this.routerHandle("corpWebsite-agreedGoods");
          break;
        case 103:
          this.routerHandle("corpWebsite-boughtGoods");
          break;
        case 104:
          this.routerHandle("corpWebsite-groupAgreedGoods");
          break;
        default:
          this.$message.info("敬请期待");
          break;
      }
    },
    routerHandle(name) {
      if (name === "rdms") {
      } else if (name) {
        this.$router.push({
          name: name,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.corpWebsite {
  font-family: Alibaba PuHuiTi;
  .corpWebsite-content {
    width: 1190px;
    margin: 0 auto;
  }
}
.menuArea {
  display: flex;
  justify-content: center;
}
.menuItem {
  margin: 8px 10px;
  padding: 8px 16px;
  min-width: 96px;
  line-height: 30px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #333;
  background: none;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    color: #2a54d1;
  }
}
.active {
  color: #2a54d1;
  font-weight: bold;
  background: #f5f6fa;
}
</style>
